import axios from 'axios'

const getSavedCreditCards = async ({ userCountry, country2Alpha, token }: { userCountry: string; country2Alpha: string; token: string }) => {
    const response = await axios.get(`https://hydra.unicity.net/v5a/customers/me/creditcardaliases/${userCountry}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'x-application': `asia.fg-${country2Alpha.toLowerCase()}`
        }
    })
    return response
}

const deleteSavedCreditCard = async ({
    cardAlias,
    userCountry,
    token,
    country2Alpha
}: {
    cardAlias: string
    userCountry: string
    token: string
    country2Alpha: string
}) => {
    const response = await axios.delete(`https://hydra.unicity.net/v5a/customers/me/creditcardaliases/${userCountry}/${cardAlias}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'x-application': `asia.fg-${country2Alpha.toLowerCase()}`
        }
    })

    return response
}

const saveCreditCard = async ({
    methodDetails,
    userCountry,
    token,
    country2Alpha
}: {
    methodDetails: Record<string, unknown>
    userCountry: string
    token: string
    country2Alpha: string
}) => {
    const response = await axios.post(
        `https://hydra.unicity.net/v5a/customers/me/creditcardaliases/${userCountry}`,
        {
            ...methodDetails
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-application': `asia.fg-${country2Alpha.toLowerCase()}`
            }
        }
    )

    return response
}

const getRemainingTime = async (_params?: { token?: string }) => {
    const response = await axios.get('https://member-calls2.unicity.com/hot/remoteStorage/data/creditcard-alias')
    return response.data
}

export const creditcardAliasApis = {
    getSavedCreditCards,
    deleteSavedCreditCard,
    saveCreditCard,
    getRemainingTime
}
